import list from './modules/list'
import summary from './modules/summary'

export default {
  namespaced: true,
  modules: {
    list,
    summary,
  },
}
